import React from 'react';
import { Badge } from 'react-bootstrap';
import { RepairPromotionEnd } from '../../constants/events';
import { useAppTranslation } from '../../i18n/useAppTranslation';

interface BuildingDetailTabProps {
  activeTab: number;
  setActiveTab: (tab: number) => void;
  isBuildingBarracks: boolean;
}

const BuildingDetailTab: React.FC<BuildingDetailTabProps> = ({
  activeTab,
  setActiveTab,
  isBuildingBarracks
}) => {
  const { t } = useAppTranslation(["village"]);
  return (
    <div className="d-flex">
      <button
        onClick={() => setActiveTab(0)}
        className="theme-btn button"
        name="upgradeTab"
      >
        <img
          className="img-fluid"
          src={
            activeTab === 0
              ? "/assets/images/buttons/active-tab-btn.png"
              : "/assets/images/buttons/off-tab-btn.png"
          }
        />
        <div className="b-text">
          <span className="text-light fs-med">{t("village:tabs.upgrade")}</span>
        </div>
      </button>
      
      {!isBuildingBarracks ? (
        <button
          onClick={() => setActiveTab(1)}
          className="theme-btn button p-relative"
          name="infoTab"
        >
          <img
            className="img-fluid"
            src={
              activeTab === 1
                ? "/assets/images/buttons/active-tab-btn.png"
                : "/assets/images/buttons/off-tab-btn.png"
            }
          />
          <div className="b-text">
            <span className="text-light fs-med">{t("village:tabs.repair")}</span>
            {RepairPromotionEnd > Date.now() && (
              <Badge className="bg-danger new-badge">🔥{t("village:labels.hot")}</Badge>
            )}
          </div>
        </button>
      ) : (
        <button
          onClick={() => setActiveTab(1)}
          className="theme-btn button p-relative"
          name="infoTab"
        >
          <img
            className="img-fluid"
            src={
              activeTab === 1
                ? "/assets/images/buttons/active-tab-btn.png"
                : "/assets/images/buttons/off-tab-btn.png"
            }
          />
          <div className="b-text">
            <span className="text-light fs-med">{t("village:tabs.info")}</span>
          </div>
        </button>
      )}
    </div>
  );
};

export default BuildingDetailTab; 
